// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6a_3s","col":"styles_col__3Rft0"};